export default "/_next/static/fonts/Graphik-BoldItalic-f63eff3efcd0fcbfb3bf6c1d60c4db40.woff2";